import { getLocaleLanguage, getLocalTime, LanguageType } from '../../../../lib';
import {
  GameEnvRegion,
  GameEnvType,
  IGameEnvModel,
  TaskDrawerType,
} from '../../../../model/api-modules/env';
import { getEnvNameByValue } from '../../../utils/env';
import devImg from '../../../../assets/img/dev-big.png';
import liveImg from '../../../../assets/img/live-big.png';
import getFormatMessage from '../../../../locales/get-format-message';
import { PermissionCheck } from '../../../component/permission-check';
import { RbacRoleObjectKey } from '../../../../model/rbac';
import { Space } from 'antd';
import classNames from 'classnames';
import { AutoTooltip } from '../../../../components/auto-tooltip';
import { renderEnvTaskStatus } from '../../../lib';
import { DeployArea } from '../../../../model';
import { getConfig } from '../../../../config';
import { IAPIUserInfo } from '../../../../model/api-modules';

const showClose = (record: IGameEnvModel, allServiceStatus: any[]) => {
  let isShow = false;
  const itemStatus = allServiceStatus.find(
    (item) => item?.result[0]?.env_id === record.Guid
  );
  if (itemStatus) {
    const task = itemStatus?.result[0]?.task;
    const openStatus = itemStatus?.result[0]?.open_status;
    // 开服并且没有任务
    if (
      (openStatus === 0 || openStatus === 1 || openStatus === 2) &&
      !task?.k8s_app_task_id
    ) {
      isShow = true;
    }
  }
  return isShow;
};

const showOpen = (record: IGameEnvModel, allServiceStatus: any[]) => {
  let isShow = false;
  const itemStatus = allServiceStatus.find(
    (item) => item?.result[0]?.env_id === record.Guid
  );
  if (itemStatus) {
    const task = itemStatus?.result[0]?.task;
    // 关服并且没有任务
    if (itemStatus.result[0]?.open_status === -1 && !task?.k8s_app_task_id) {
      isShow = true;
    }
  }
  return isShow;
};

const showViewPlan = (record: IGameEnvModel, allServiceStatus: any[]) => {
  let isShow = false;
  const itemStatus = allServiceStatus.find(
    (item) => item?.result[0]?.env_id === record.Guid
  );
  if (itemStatus) {
    const task = itemStatus?.result[0]?.task;
    // 关服并且有开服任务
    if (itemStatus.result[0]?.open_status === -1 && task?.k8s_app_task_id) {
      isShow = true;
    }
    // 开服并且有关服任务
    if (itemStatus.result[0]?.open_status !== -1 && task?.k8s_app_task_id) {
      isShow = true;
    }
  }
  return isShow;
};

const compareVersions = (versionA: string, versionB: string) => {
  const currentVersionA = versionA || 'v0.0.0';
  // 移除开头的'v'并分割为数字数组
  const partsA = currentVersionA
    .replace(/^v/, '')
    .replace(/-.*$/, '')
    .split('.')
    .map(Number);
  const partsB = versionB
    .replace(/^v/, '')
    .replace(/-.*$/, '')
    .split('.')
    .map(Number);

  // 比较每个部分
  for (let i = 0; i < Math.max(partsA.length, partsB.length); i++) {
    const a = partsA[i] || 0;
    const b = partsB[i] || 0;

    if (a > b) return 1;
    if (a < b) return -1;
  }

  return 0;
};

// 判断 version 是否大于等于 targetVersion
const isVersionGreaterThan = (version: string, targetVersion: string) => {
  return compareVersions(version, targetVersion) >= 0;
};

const renderBtn = (
  onViewPlan: (record: IGameEnvModel, type: string) => void,
  record: IGameEnvModel,
  type: string,
  text: string
) => {
  const gos = JSON.parse(record?.GosParams || '{}');
  if (isVersionGreaterThan(gos?.GameServiceVersion, 'v1.9.0')) {
    return (
      <PermissionCheck
        permissionKey={RbacRoleObjectKey.EnvironmentServerStartAndStop}
        tipsPlacement="top"
        gameID={record.GameID}
        envID={record.id.toString()}
      >
        <a
          style={{
            margin: '0 10px',
          }}
          onClick={() => {
            onViewPlan(record, type);
          }}
        >
          {getFormatMessage(text)}
        </a>
      </PermissionCheck>
    );
  }
  return (
    <PermissionCheck
      permissionKey={RbacRoleObjectKey.EnvironmentServerStartAndStop}
      tipsPlacement="top"
      gameID={record.GameID}
      otherTips={getFormatMessage('version_too_low')}
    >
      <a
        style={{
          margin: '0 10px',
          cursor: 'not-allowed',
          opacity: 0.5,
        }}
      >
        {getFormatMessage(text)}
      </a>
    </PermissionCheck>
  );
};

export const getColumns = (
  onEdit: (record: IGameEnvModel) => void,
  onDelete: (record: IGameEnvModel) => void,
  onViewPlan: (record: IGameEnvModel, type: string) => void,
  clickEnvItem: (record: IGameEnvModel) => void,
  allServiceStatus: any[],
  isHasVersion: boolean,
  userInfo: IAPIUserInfo | null
) => [
  {
    key: 'Type',
    name: getFormatMessage('admin_env_type'),
    tableExtension: {
      renderRow(key: string, value: GameEnvType) {
        // let tagStyle = {};
        let imgUrl = '';
        if (value === GameEnvType.Live) {
          imgUrl = liveImg;
          // tagStyle = {
          //   backgroundImage: `url(${liveImg})`,
          //   width: '40px',
          //   height: '20px',
          // };
        } else if (value === GameEnvType.Dev) {
          imgUrl = devImg;
          // tagStyle = {
          //   backgroundImage: `url(${devImg})`,
          //   width: '40px',
          //   height: '20px'
          // };
        }
        return (
          <div className="first-column">
            <img src={imgUrl} style={{ width: 40, height: 20 }} />
            {/* <div style={tagStyle}></div> */}
          </div>
        );
      },
      fixed: 'left',
      width: 80,
    },
  },
  {
    name: getFormatMessage('env_table_id'),
    key: 'id',
    tableExtension: {
      fixed: 'left',
      width: 96,
    },
  },
  {
    name: getFormatMessage('env_table_name'),
    key: 'Name',
    tableExtension: {
      fixed: 'left',
      width: 144,
      renderRow(key: string, value: string, row: IGameEnvModel) {
        return (
          <div
            style={{ cursor: 'pointer', color: '#5764f1' }}
            onClick={() => clickEnvItem(row)}
          >
            {value}
          </div>
        );
      },
    },
  },
  {
    name: getFormatMessage('region'),
    key: 'Region',
    tableExtension: {
      renderRow(key: string, value: GameEnvRegion) {
        const deployArea: DeployArea = getConfig()?.deployArea;
        const isWoa = deployArea === DeployArea.woa;
        const displayText =
          isWoa && value === GameEnvRegion.Woa
            ? getFormatMessage('idc_label_type')
            : getEnvNameByValue(value);
        return <div>{displayText}</div>;
      },
    },
  },
  {
    name: getFormatMessage('status'),
    key: 'Guid',
    tableExtension: {
      width: 215,
      className: isHasVersion ? '' : 'hideColumn',
      rowTdClassName: isHasVersion ? '' : 'hideColumn',
      renderRow(key: string, value: string) {
        const taskInfo = allServiceStatus.find(
          (item) => item?.result[0]?.env_id === value
        )?.result?.[0];
        return renderEnvTaskStatus(taskInfo);
      },
    },
  },
  {
    name: getFormatMessage('desc_information'),
    key: 'Description',
    tableExtension: {
      width: 240,
      renderRow(key: string, value: string) {
        return (
          <div className="custom-tooltip-container">
            <AutoTooltip title={value || '--'} placement="bottom">
              <div
                style={{
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {value || '--'}
              </div>
            </AutoTooltip>
          </div>
        );
      },
    },
  },
  {
    name: getFormatMessage('service_version'),
    key: 'GosParams',
    tableExtension: {
      className: isHasVersion ? '' : 'hideColumn',
      rowTdClassName: isHasVersion ? '' : 'hideColumn',
      width: 110,
      renderRow(key: string, value: string) {
        const gos = JSON.parse(value || '{}');
        const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
        return (
          <div className="custom-tooltip-container">
            <div className="gate-address" style={{ cursor: 'text' }}>
              {gos?.GameServiceVersion || '--'}
            </div>
            {!gos?.GameServiceVersion && (
              <div
                className={`custom-tooltip ${
                  currentStoreLanguage === LanguageType.zh_CN
                    ? ' custom-tooltip-cn'
                    : ''
                }`}
              >
                <span> {getFormatMessage('after_service_activated_desc')}</span>
              </div>
            )}
          </div>
        );
      },
    },
  },
  // {
  //   name: getFormatMessage('server_url'),
  //   key: 'GosParams',
  //   tableExtension: {
  //     className: isHasVersion ? '' : 'hideColumn',
  //     rowTdClassName: isHasVersion ? '' : 'hideColumn',
  //     renderRow(key: string, value: string) {
  //       const gos = JSON.parse(value || '{}');
  //       const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  //       return (
  //         <div className="custom-tooltip-container">
  //           <AutoTooltip title={gos?.BianQueAddr || '--'} placement="bottom">
  //             <div className="gate-address">{gos?.BianQueAddr || '--'}</div>
  //           </AutoTooltip>
  //           {!gos?.BianQueAddr && (
  //             <div
  //               className={`custom-tooltip ${currentStoreLanguage === LanguageType.zh_CN
  //                 ? ' custom-tooltip-cn'
  //                 : ''
  //                 }`}
  //             >
  //               <span>{getFormatMessage('after_service_activated_desc')}</span>
  //             </div>
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  // },
  // {
  //   name: getFormatMessage('gate_address'),
  //   key: 'GosParams',
  //   tableExtension: {
  //     className: isHasVersion ? '' : 'hideColumn',
  //     rowTdClassName: isHasVersion ? '' : 'hideColumn',
  //     renderRow(key: string, value: string) {
  //       const gos = JSON.parse(value || '{}');
  //       const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  //       return (
  //         <div className="custom-tooltip-container">
  //           <AutoTooltip title={gos?.GateAddress || '--'} placement="bottom">
  //             <div className="gate-address">{gos?.GateAddress || '--'}</div>
  //           </AutoTooltip>
  //           {!gos?.GateAddress && (
  //             <div
  //               className={`custom-tooltip ${currentStoreLanguage === LanguageType.zh_CN
  //                 ? ' custom-tooltip-cn'
  //                 : ''
  //                 }`}
  //             >
  //               <span>{getFormatMessage('after_service_activated_desc')}</span>
  //             </div>
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  // },
  // {
  //   name: getFormatMessage('realm_url'),
  //   key: 'GosParams',
  //   tableExtension: {
  //     className: isHasVersion ? '' : 'hideColumn',
  //     rowTdClassName: isHasVersion ? '' : 'hideColumn',
  //     renderRow(key: string, value: string) {
  //       const gos = JSON.parse(value || '{}');
  //       const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  //       return (
  //         <div className="custom-tooltip-container">
  //           <AutoTooltip title={gos?.ReamURL || '--'} placement="bottom">
  //             <div className="gate-address">{gos?.ReamURL || '--'}</div>
  //           </AutoTooltip>
  //           {!gos?.ReamURL && (
  //             <div
  //               className={`custom-tooltip ${currentStoreLanguage === LanguageType.zh_CN
  //                 ? ' custom-tooltip-cn'
  //                 : ''
  //                 }`}
  //             >
  //               <span>{getFormatMessage('after_service_activated_desc')}</span>
  //             </div>
  //           )}
  //         </div>
  //       );
  //     },
  //   },
  // },
  {
    name: getFormatMessage('create_by'),
    key: 'FounderUid',
    tableExtension: {
      renderRow(key: string, value: string) {
        if (value) {
          return value;
        }
        return getFormatMessage('system');
      },
    },
  },
  {
    name: getFormatMessage('create_time_local'),
    key: 'CreateTime',
    tableExtension: {
      renderRow(key: string, value: Date) {
        return getLocalTime(value, userInfo?.UserSettings?.Timezone);
      },
    },
  },
  {
    name: getFormatMessage('operate'),
    key: 'Operate',
    tableExtension: {
      renderRow(key: string, value: any, row: IGameEnvModel) {
        const record = row as IGameEnvModel;
        return (
          <Space size="middle" className={classNames('operate-btn')}>
            <div className="webkit-box flex-left">
              <PermissionCheck
                permissionKey={RbacRoleObjectKey.EnvCreate}
                tipsPlacement="left"
                gameID={record.GameID}
              >
                <a
                  style={{
                    marginRight: '10px',
                  }}
                  onClick={() => onEdit(record)}
                >
                  {getFormatMessage('edit')}
                </a>
              </PermissionCheck>
              {showViewPlan(record, allServiceStatus) &&
                renderBtn(
                  onViewPlan,
                  record,
                  TaskDrawerType.ViewPlan,
                  'view_plan'
                )}
              {showClose(record, allServiceStatus) &&
                renderBtn(
                  onViewPlan,
                  record,
                  TaskDrawerType.OpenType,
                  'open_type'
                )}
              {showOpen(record, allServiceStatus) &&
                renderBtn(
                  onViewPlan,
                  record,
                  TaskDrawerType.Open,
                  'service_open'
                )}
              {showClose(record, allServiceStatus) &&
                renderBtn(
                  onViewPlan,
                  record,
                  TaskDrawerType.Close,
                  'service_close'
                )}
              <PermissionCheck
                permissionKey={RbacRoleObjectKey.EnvDelete}
                tipsPlacement="left"
                gameID={record.GameID}
              >
                <span
                  style={{
                    color: '#F54E4E',
                    marginLeft: '10px',
                    cursor: 'pointer',
                  }}
                  onClick={() => onDelete(record)}
                >
                  {getFormatMessage('delete')}
                </span>
                {/* )} */}
              </PermissionCheck>
            </div>
          </Space>
        );
      },
      width: 250,
      fixed: 'right',
    },
  },
];
